import React from 'react';

import i18n from 'i18next';
import { TabsContainer } from '@/exceed';

import { Loading } from 'uikit/loaders';

import getDashboardFilters from '../helpers/getDashboardFilters';

import InsightsDashboardContainer from '../containers/insightsDashboardContainer';

import InsightsDashboardsEmpty from './insightsDashboardsEmpty';

import styles from '../styles/insightsDashboards.module.scss';

const InsightsDashboards = ({
  dashboards,
  dashboardableId,
  dashboardableType,
  isLoading,
}) => {
  if (isLoading) return <Loading className={styles.element} />;

  // Extract the current URI Query parameters to be transfered to the tabs URI
  let currentURIQueryParams = new URLSearchParams(window.location.search);
  let queryString = currentURIQueryParams.toString();

  return !dashboards.length ? <InsightsDashboardsEmpty /> : (
    <TabsContainer
      id="dashboard"
      direction="vertical"
      shouldRenderAll={false}
      tabs={dashboards.map(({ id, ...dashboard }, index) => ({
        id: `${String(id)}?${queryString}`,
        title: i18n.t(dashboard.type),
        body: (
          <InsightsDashboardContainer
            dashboardableId={dashboardableId}
            dashboardableType={dashboardableType}
            description={dashboard.description}
            filters={getDashboardFilters(dashboard.filters)}
            id={id}
            isEmpty={dashboard.show_empty_state}
            nextDashboard={dashboards[index + 1]}
            timestamp={dashboard.last_updated_at_epoch}
            title={dashboard.display_name}
          />
        ),
      }))}
    />
  );
};

export default React.memo(InsightsDashboards);
